import { GetStaticPaths, GetStaticProps } from 'next';

import ApiService from '@/lib/api';
import BlogList from '@/components/Blog/BlogList';
import MainLayout from '../../layouts/MainLayout';
import { groupTags } from '@/utils/helpers';
import retiredTags from '../../../retired-tags';

export const getStaticPaths: GetStaticPaths = async () => {
  const apiService = new ApiService();
  const data = await apiService.getBlogTags();
  const tagList = groupTags(data).filter((route) => !retiredTags.includes(route.slug));

  return {
    paths: tagList.map((route) => ({
      params: { slug: route.slug },
    })),
    fallback: true,
  };
};

export const getStaticProps: GetStaticProps = async ({ params: { slug } }) => {
  const postsPerPage = 20;
  const currentPage = 0;
  const apiService = new ApiService();
  const tag = Array.isArray(slug) ? slug[0].replace(/-/g, ' ') : slug.replace(/-/g, ' ');
  const [data, menuData, { footer }] = await Promise.all([
    apiService.getBlogPostByTag(tag as string, currentPage, postsPerPage),
    apiService.getMenuData(),
    apiService.getMiscData(),
  ]);
  const blogsLength = data.length;
  const numPages = Math.ceil(blogsLength / postsPerPage);
  const tagHeader = `${blogsLength} post${blogsLength === 1 ? '' : 's'} tagged with “${tag}”`;

  return {
    props: {
      tag,
      posts: data,
      tagHeader,
      currentPage,
      numPages,
      menuData,
      footer,
    },
    revalidate: 3600,
  };
};

const CulturePage = ({ posts, tag, currentPage, tagHeader, numPages, menuData, footer }) => {
  const ogUrl = tag ? `https://foxbox.com/tags/${tag.replace(/ /g, '-')}` : undefined;
  return (
    <MainLayout
      ogUrl={ogUrl}
      bgWhite={true}
      navIsFixed={false}
      navIsDark={true}
      menuData={menuData}
      footer={footer}
      metaTitle={`${tag} | Foxbox Digital Blog Tags`}
      metaDescription={`Foxbox Digital blog posts with tag ${tag}`}
    >
      <BlogList
        posts={posts}
        numPages={numPages}
        currentPage={currentPage + 1}
        isTagList
        blogListCopy={{
          heading: tag,
          subheading: tagHeader,
        }}
      />
    </MainLayout>
  );
};

export default CulturePage;
